import { render } from "./BaseCollapsible.vue?vue&type=template&id=3aae718e&scoped=true&ts=true"
import script from "./BaseCollapsible.vue?vue&type=script&lang=ts"
export * from "./BaseCollapsible.vue?vue&type=script&lang=ts"

import "./BaseCollapsible.vue?vue&type=style&index=0&id=3aae718e&scoped=true&lang=scss"

import exportComponent from "/builds/Chirbou/digithia/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aae718e"]])

export default __exports__